module.exports = __webpack_public_path__ + "8a164d1e1692c02cfd2b87e6e2492302.svg";